<template>
  <NebulaTooltip
    class="immersive-reader"
    :class="useFloatingStyle && 'immersive-reader--floating'"
    :position="tooltipPosition"
    :text="$t('Immersive Reader')"
  >
    <button
      class="immersive-reader__button"
      :class="buttonClasses"
      :aria-label="$t('Immersive Reader')"
      @click="onLaunchImmersiveReader"
    >
      <NebulaIcon
        symbol-id="immersive-reader"
        :class-override="iconClasses"
      />
    </button>
  </NebulaTooltip>
</template>

<script>
import { NebulaIcon, NebulaTooltip } from '@discoveryedu/nebula-components';
import { mapState } from 'pinia';
import immersiveReader from '@/mixins/immersiveReader';
import {
  useUserStore,
} from '@/stores';

export default {
  name: 'ImmersiveReader',
  components: {
    NebulaIcon,
    NebulaTooltip,
  },
  mixins: [immersiveReader],
  props: {
    mode: {
      type: String, // used in the immersiveReader mixin
      required: true,
    },
    useFloatingStyle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useUserStore, [
      'isRtl',
    ]),
    buttonClasses() {
      if (this.useFloatingStyle) {
        return 'nebula-button nebula-button--icon-only nebula-button--m';
      }

      return 'comet-button comet-button--secondary comet-button--icon-only';
    },
    iconClasses() {
      if (this.useFloatingStyle) {
        return 'nebula-button__icon';
      }

      return 'comet-button__icon comet-button__icon--left';
    },
    tooltipPosition() {
      if (this.useFloatingStyle) return 'bottom';

      return this.isRtl ? 'right' : 'left';
    },
  },
  methods: {
    onLaunchImmersiveReader() {
      // Swallow errors since messaging is handled inside launchImmersiveReader()
      this.launchImmersiveReader().catch(() => {});
    },
  },
};
</script>

<style lang="stylus">
.immersive-reader {
  display: block;
  width: 52px;

  &--floating {
    width: auto;
  }

  &__button.comet-button {
    border-radius: $nebula-border-radius-badge-default 0 0 $nebula-border-radius-badge-default;
    margin: 0;
  }

  html[dir="rtl"] & {
    &__button.comet-button {
      border-radius: 0 $nebula-border-radius-badge-default $nebula-border-radius-badge-default 0;
      margin: 0;
    }
  }
}
</style>
